import styled from 'styled-components'

export const BodyContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 24px;
  justify-content: space-between;
  align-items: flex-start;
`

export const Title = styled.p`
  font-size: 16px;
  line-height: 20px;
  width: 100%;
  max-width: 280px;
  font-weight: 600;
  padding-left: 10px;
  margin: 0;
  color: ${({ theme }) => theme.colors.alternativeError};
  @media (min-width: ${({ theme }) => theme.screen.mdMin}) {
    font-size: 18px;
  }
`

export const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
`

export const DescriptionContainer = styled.span`
  margin: 8px 0;
  width: 100%;
`
export const Description = styled.p`
  font-size: 14px;
  margin: 5px 0;
  @media (min-width: ${({ theme }) => theme.screen.mdMin}) {
    font-size: 16px;
  }
`
export const Email = styled(Description)`
  color: ${({ theme }) => theme.colors.primary.normal};
  font-weight: 600;
`
